export default "https://cdn-static.gokick.com/assets/f4ff00fe02dd4df624a9917ee1bd81ca642b4b73/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";